import React from "react";
import { Checkbox, Table, Text } from "@mantine/core";
import { useAppSelector } from "../app/hooks";
import { selectVisibleModulesForCurrentProject } from "../projectSelectors";

type Props = {
  accessByModule: Record<string, boolean>;
  onChange: (next: Record<string, boolean>) => void;
};

export const ModulePermissionsMatrix: React.FC<Props> = ({ accessByModule, onChange }) => {
  const modules = useAppSelector(selectVisibleModulesForCurrentProject);
  return (
    <>
      <Text fw={600}>Moduler</Text>
      <Table withColumnBorders withTableBorder>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Modul</Table.Th>
            <Table.Th style={{ width: 120 }}>Tilgang</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {modules.map((module) => (
            <Table.Tr key={module.key}>
              <Table.Td>{module.title}</Table.Td>
              <Table.Td>
                <Checkbox
                  aria-label={`Tilgang til ${module.title}`}
                  checked={accessByModule[module.key] ?? false}
                  onChange={(event) => onChange({ ...accessByModule, [module.key]: event.currentTarget.checked })}
                />
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </>
  );
};
